import { Component, For } from "solid-js";
import { taxTypeNames } from "~/mydata";
import { InvoiceItem, ItemTax, itemTaxAmount } from "~/onesign/invoice-totals";
import { findTax } from "~/onesign/taxes";
import AmountInput from "./AmountInput";
import { replaceDotWithComma } from "./helpers";

const InvoiceItemTaxes: Component<{
  taxes: ItemTax[];
  item: InvoiceItem;
}> = (props) => {
  return (
    <>
      <For each={props.taxes}>
        {(tax) => (
          <div class="row gx-2 mb-2 pb-2 border-bottom">
            <div class="col mb-2">
              <p class="">
                <span class="badge bg-secondary p-2">{taxTypeNames[tax.type]}</span>{" "}
                {findTax(tax.type, tax.category)?.title}
              </p>
            </div>
            <div class="col-md-3 align-top">
              <AmountInput
                class="form-control text-end p-2"
                disabled
                value={
                  replaceDotWithComma(
                    itemTaxAmount(tax, props.item)?.toFixed(2)
                  )
                }
              />
            </div>
          </div>
        )}
      </For>
    </>
  );
};
export default InvoiceItemTaxes;
